import './style.scss'

import React, { Component } from 'react'

import PropTypes from 'prop-types'

export default class SearchResultDropdownItem extends Component {
    render() {
        const { vendor, title, image = null, onClick } = this.props
        const className = 'search-result-dropdown-item'

        return (
            <div className={className} onClick={onClick}>
                {image && <img className={`${className}__image`} src={image} alt={title} />}
                <div>
                    <div className={`${className}__vendor`}>{vendor}</div>
                    <h4 className={`${className}__title`}>{title}</h4>
                </div>
            </div>
        )
    }
}

SearchResultDropdownItem.propTypes = {
    vendor: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.string,
    onClick: PropTypes.func,
}
